import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "agenda-public-page"
  }, [_c('div', {
    staticClass: "agenda-public-shell"
  }, [_c('h1', [_vm._v("Agende seu horário")]), _vm.loading ? _c('div', {
    staticClass: "agenda-public-state"
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Carregando horários... ")], 1) : _vm.error ? _c('div', {
    staticClass: "alert alert-light-danger"
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")]) : _vm.confirmedSlot ? [_c('div', {
    staticClass: "agenda-public-confirmation"
  }, [_c('strong', [_vm._v("Horário agendado com sucesso.")]), _c('span', [_vm._v(" " + _vm._s(_vm.formatDate(_vm.confirmedSlot.inicio)) + " das " + _vm._s(_vm.formatTime(_vm.confirmedSlot.inicio)) + " às " + _vm._s(_vm.formatTime(_vm.confirmedSlot.fim)) + " ")])]), _c('div', {
    staticClass: "agenda-public-confirmation-footer"
  }, [_c('img', {
    staticClass: "agenda-public-logo",
    attrs: {
      "alt": "Logo Nuts Tecnologia",
      "src": _vm.layoutConfig('self.logo.secundary')
    }
  })])] : [_c('div', {
    staticClass: "agenda-public-meta"
  }, [_c('span', [_vm._v(_vm._s(_vm.availableSlotsCount) + " horários disponíveis")]), _vm.disabledSlotsCount ? _c('span', [_vm._v(" " + _vm._s(_vm.disabledSlotsCount) + " horários indisponíveis ")]) : _vm._e(), _vm.link.servico ? _c('span', [_vm._v(_vm._s(_vm.link.servico.discriminacao))]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.link.duracao_minutos) + " min")])]), _vm.slots.length === 0 ? _c('div', {
    staticClass: "agenda-public-state"
  }, [_vm._v(" Nenhum horário disponível para este link. ")]) : [_vm.availableDays.length > 1 ? _c('div', {
    staticClass: "agenda-public-day-picker"
  }, [_c('button', {
    staticClass: "btn btn-light-primary agenda-public-day-arrow",
    attrs: {
      "type": "button",
      "title": "Dia anterior",
      "disabled": !_vm.hasPreviousDay
    },
    on: {
      "click": _vm.goToPreviousDay
    }
  }, [_c('ChevronLeft', {
    attrs: {
      "size": 18
    }
  })], 1), _c('div', {
    staticClass: "agenda-public-days"
  }, _vm._l(_vm.availableDays, function (day) {
    return _c('button', {
      key: day.key,
      staticClass: "agenda-public-day",
      class: {
        active: day.key === _vm.activeDayKey
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.changeDay(day.key);
        }
      }
    }, [_c('CalendarCheck', {
      attrs: {
        "size": 18
      }
    }), _c('span', [_vm._v(_vm._s(day.label))]), _c('small', [_vm._v(_vm._s(day.available) + " horários")])], 1);
  }), 0), _c('button', {
    staticClass: "btn btn-light-primary agenda-public-day-arrow",
    attrs: {
      "type": "button",
      "title": "Próximo dia",
      "disabled": !_vm.hasNextDay
    },
    on: {
      "click": _vm.goToNextDay
    }
  }, [_c('ChevronRight', {
    attrs: {
      "size": 18
    }
  })], 1)]) : _vm._e(), _vm.activeDay ? _c('div', {
    staticClass: "agenda-public-day-summary"
  }, [_c('strong', [_vm._v(_vm._s(_vm.activeDay.weekday))]), _c('span', [_vm._v(_vm._s(_vm.activeDay.longLabel))])]) : _vm._e(), _vm.activeDaySlots.length === 0 ? _c('div', {
    staticClass: "agenda-public-state"
  }, [_vm._v(" Nenhum horário disponível neste dia. ")]) : _c('div', {
    staticClass: "agenda-public-slots"
  }, _vm._l(_vm.activeDaySlots, function (slot) {
    return _c('button', {
      key: slot.inicio,
      staticClass: "agenda-public-slot",
      class: {
        selected: _vm.selectedSlot && _vm.selectedSlot.inicio === slot.inicio,
        unavailable: _vm.isSlotPast(slot)
      },
      attrs: {
        "type": "button",
        "disabled": _vm.isSlotPast(slot)
      },
      on: {
        "click": function click($event) {
          return _vm.selectSlot(slot);
        }
      }
    }, [_c('strong', [_vm._v(" " + _vm._s(_vm.formatTime(slot.inicio)) + " - " + _vm._s(_vm.formatTime(slot.fim)) + " ")])]);
  }), 0)], _c('div', {
    staticClass: "agenda-public-form"
  }, [!_vm.link.id_pessoa ? _c('b-form-group', {
    attrs: {
      "label": "Código do cliente",
      "label-for": "id_pessoa"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "id_pessoa"
    },
    model: {
      value: _vm.idPessoa,
      callback: function callback($$v) {
        _vm.idPessoa = $$v;
      },
      expression: "idPessoa"
    }
  })], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label": "Observações"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3"
    },
    model: {
      value: _vm.observacoes,
      callback: function callback($$v) {
        _vm.observacoes = $$v;
      },
      expression: "observacoes"
    }
  })], 1), _c('div', {
    staticClass: "agenda-public-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedSlot || _vm.saving
    },
    on: {
      "click": _vm.confirmar
    }
  }, [_vm._v(" " + _vm._s(_vm.saving ? "Confirmando..." : "Confirmar horário") + " ")]), _c('img', {
    staticClass: "agenda-public-logo",
    attrs: {
      "alt": "Logo",
      "src": _vm.layoutConfig('self.logo.secundary')
    }
  })])], 1)]], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };